import * as React from 'react';

// ICONS
import { ReactComponent as DragDownIcon } from '../assets/svg/drag-down.svg';
import { ReactComponent as DragIcon } from '../assets/svg/drag.svg';
import { ReactComponent as DragUpIcon } from '../assets/svg/drag-up.svg';

// TYPES
interface DisplayDragIconTypes {
	index: number;
	array: any[];
}

const DisplayDragIcon: React.FC<DisplayDragIconTypes> = ({ index, array }) => {
	const renderDragIcon = () => {
		if (index === 0) {
			return <DragDownIcon className="drag-icon" />;
		} else if (index === array.length - 1) {
			return <DragUpIcon className="drag-icon" />;
		} else {
			return <DragIcon className="drag-icon" />;
		}
	};

	return <>{renderDragIcon()}</>;
};

export default DisplayDragIcon;
